<script>
    import {API_URL} from "../../env";
    import {shoppingCart, showShoppingCart} from "../js/stores";
    import Error from "../placeholders/Error.svelte";
    import { Tooltip } from "@svelte-plugins/tooltips";
    import HomeCarousel from "../components/routes/HomeCarousel.svelte";
    import WarehouseSelect from "../components/routes/WarehouseSelect.svelte";
    import ContentLoading from '../placeholders/ContentLoading.svelte';
    import {onMount} from "svelte";

    window.scrollTo(0, 0);

    export let params = {}
    $: data = fetchData(params.id)
    let variantIds = []

    async function fetchData (id) {
        if (!id) return;
        const res = await fetch(API_URL+'/product/'+id);
        const body = await res.json();
        // $: console.table('Product detail', body);
        body.variants = body.variants.filter(v => v.stock > 0)

        body.variants.forEach(variant => {
            variantIds.push(variant.supplier_id)
            body.variants[body.variants.indexOf(variant)].value = variant.supplier_id;
            body.variants[body.variants.indexOf(variant)].label = `Sklad ${variant.supplier_id} (${variant.stock}ks)`;

            // variant.delivery edit, now its "2-3" days, should be actual date + 3 work days in j.n.Y format except weekends
            let delivery = new Date()
            delivery.setDate(delivery.getDate() + 3)

            if (delivery.getDay() === 6) delivery.setDate(delivery.getDate() + 3)
            if (delivery.getDay() === 0) delivery.setDate(delivery.getDate() + 2)
            if (delivery.getDay() === 1) delivery.setDate(delivery.getDate() + 1)


            body.variants[body.variants.indexOf(variant)].delivery = delivery.toLocaleDateString('sk-SK', {day: 'numeric', month: 'numeric', year: 'numeric'})
        })

        selectedVariant = body.variants[0]
        return body
    }

    let amount = 1;
    let selectedVariant = null;

    function chooseSeasonText(season) {
        switch (season) {
            case 'Letní':
                return '<img src="/assets/img/icons/sun.svg" alt="Ikona sezóny"> Letná'
            case 'Zimní':
                return '<img src="/assets/img/icons/snowflake.svg" alt="Ikona sezóny"> Zimná'
            case 'Celoroční':
                return '<img src="/assets/img/icons/wholeyear.svg" alt="Ikona sezóny"> Celoročná'
            default:
                return ''
        }
    }

    function pickColor(value) {
        switch (value) {
            case 'A':
                return '#00A943'
            case 'B':
                return '#51B842'
            case 'C':
                return '#C0D437'
            case 'D':
                return '#FFF000'
            case 'E':
                return '#FFB41C'
            case 'F':
                return '#EC7517'
            case 'G':
                return '#EB1C26'
            default:
                return '#1095D6'
        }
    }

    function handleAmountChanged() {
        if (amount < 0) {
            amount = 1
        }
        else if (amount > selectedVariant.stock) {
            amount = selectedVariant.stock
        }
    }

    function handleSelectVariant(variant) {
        amount = 1;
        selectedVariant = variant.detail;
    }

    async function fastBuy(){
        await addToShoppingCart(false);
        window.location.href = '/#/suhrn';
    }

    async function addToShoppingCart (showCart = true) {
        if (amount === 0) return

        if (amount < 1 || amount > 99) return addAlert("danger", "Chyba", 'Chybný počet kusov na pridanie do košíka! Zadajte množstvo v rozmedzí 1 až 99 kusov.')
        if (!selectedVariant) return addAlert("danger", "Chyba", 'Nie je vybraný žiadny sklad.')

        let resolved = await Promise.resolve(data)

        let body = {
            product_id: resolved.id,
            variant: selectedVariant.supplier_id,
            amount,
            price: selectedVariant.price
        }

        const res = await fetch(API_URL + '/shoppingCart/add', {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })

        if (!res.ok) {
            console.error('Add item to shopping cart fetch error!', await res.json())
            return
        }

        const cartItems = await res.json()
        // const insertedCartItems = cartItems[cartItems.length - 1]
        const insertedCartItem = cartItems.find(v => v.product_id === body.product_id && v.variant === body.variant)

        let itemExists = $shoppingCart.find(v => v.id === insertedCartItem.id)

        if (itemExists) {
            itemExists.amount = insertedCartItem.amount
            itemExists.price = insertedCartItem.price

            showShoppingCart.set(true)

            return
        }

        // Second fetch => fetching products info
        const res2 = await fetch(API_URL + '/product/' + resolved.id)

        if (!res2.ok) return console.error('Fetching product info error!', await res2.json());

        insertedCartItem.product = await res2.json()

        shoppingCart.set([...$shoppingCart, insertedCartItem])

        if(showCart) showShoppingCart.set(true)
    }

    onMount(() => {
        (function(t, r, a, c, k, i, n, g) {t['ROIDataObject'] = k;
            t[k]=t[k]||function(){(t[k].q=t[k].q||[]).push(arguments)},t[k].c=i;n=r.createElement(a),
                g=r.getElementsByTagName(a)[0];n.async=1;n.src=c;g.parentNode.insertBefore(n,g)
        })(window, document, 'script', '//www.heureka.sk/ocm/sdk.js?version=2&page=product_detail', 'heureka', 'sk');
    })

    let demoPattern = /(^|\s)DEMO($|\s)/
</script>

<HomeCarousel/>

<section class="product">
    <div class="container">
        <div class="row">
            {#await data}
                <div class="col-12">
                    <ContentLoading/>
                </div>
            {:then data}
                <div class="col-xxl-3">
                    <div class="product-image {variantIds.length === 1 ? 'single' : 'multiple'}" class:unavailable={variantIds.length < 1}>
                        <img src={data.picture || './assets/img/nahled.webp'} alt="Fotografia pneumatiky {data.name.replace(demoPattern, ' ')}">
                    </div>
                </div>
                <div class="col-xxl-9">
                    <div class="row">
                        <div class="col-12">
                            <div class="product-header mb-4">
                                <div class="row d-flex align-items-center">
                                    <div class="col-lg-8 d-flex justify-content-center justify-content-lg-start">
                                        <div class="product-brand">
                                            <div class="product-logo">
                                                {#if data?.manufacturer_logo?.length > 0}
                                                    <img src={data.manufacturer_logo} alt="Logo výrobcu {data.manufacturer || '-'}">
                                                {:else}
                                                    <span>{data.manufacturer || '-'}</span>
                                                {/if}
                                            </div>
                                            <h2>{data.name.replace(demoPattern, ' ')}</h2>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 mt-4 mt-lg-0 d-flex justify-content-center justify-content-lg-end">
                                        <div class="product-specs">
                                            <div class="spec-item">
                                                šírka
                                                <span>{data.width}</span>
                                            </div>
                                            <div class="spec-item">
                                                profil
                                                <span>{data.profile}</span>
                                            </div>
                                            <div class="spec-item">
                                                priemer
                                                <span>{data.diameter}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="product-desc mb-4" class:mb-lg-0={variantIds.length <= 1}>
                                <h3>Špecifikácia:</h3>
                                <div class="desc-stats">
                                    <Tooltip maxWidth={500} content="Brzdenie na mokrej vozovke" autoPosition="true">
                                        <div class="stats-item">
                                            <i class="fas fa-fw fa-cloud-rain"></i>
                                            <span style="background-color: {pickColor(data.adhesion)}26; color: {pickColor(data.adhesion)}">{data.adhesion || '-'}</span>
                                        </div>
                                    </Tooltip>
                                    <Tooltip content="Úspora - valivý odpor">
                                        <div class="stats-item">
                                            <i class="fas fa-fw fa-gas-pump"></i>
                                            <span style="background-color: {pickColor(data.rolling_resistance)}26; color: {pickColor(data.rolling_resistance)}">{data.rolling_resistance || '-'}</span>
                                        </div>
                                    </Tooltip>
                                    <Tooltip content="Vonkajšia hlučnosť">
                                        <div class="stats-item">
                                            <i class="fas fa-fw fa-waveform-lines"></i>
                                            <span style="background-color: {pickColor(data.noise)}26; color: {pickColor(data.noise)}">{(data.noise)? data.noise + 'dB' : '-'}</span>
                                        </div>
                                    </Tooltip>
                                </div>
                                <ul>
                                    <li>Výrobca: <span>{data.manufacturer || '-'}</span></li>
                                    <li>Sezóna: <span>{@html chooseSeasonText(data.season) || '-'}</span></li>
                                    <li>Rýchlostný index: <span>{data.speed_index || '-'}</span></li>
                                    <li>Index nosnosti: <span>{data.weight_index || '-'}</span></li>
                                    <li>EAN: <span>{data.ean || '-'}</span></li>
                                    {#if variantIds.length === 1}
                                        <li>Rok výroby:
                                            <span>
                                                {#if selectedVariant?.manufacture_year}
                                                    {selectedVariant?.manufacture_year}
                                                {:else}
                                                    <Tooltip maxWidth={500} animation="" content="Rok výroby tejto pneumatiky nemusí byť presný, nakoľko ho dodávateľ neudáva, no zvyčajne sa jedná o rok 2024. Ak vyžadujete špecifický rok výroby tejto pneumatiky, napíšte to prosím do poznámky pri objednávke.">
                                                        <u>2024</u>
                                                    </Tooltip>
                                                {/if}
                                            </span>
                                        </li>
                                    {/if}
                                </ul>
                                {#if variantIds.length === 1}
                                    <div class="product-price">{selectedVariant.price.toFixed(2)}€</div>
                                {/if}
                            </div>
                            {#if variantIds.length > 1}
                                <div class="product-delivery mb-4 mb-lg-0">
                                    {#if selectedVariant}
                                        {#if selectedVariant.stock > 0}
                                            <div class="delivery-item status">
                                                <i class="fad fa-fw fa-truck-fast"></i>
                                                <b>Doručenie</b>
                                                <p>Skladom ({selectedVariant.stock}ks)<br/>Predpokladané doručenie {selectedVariant.delivery}</p>
                                            </div>
                                            <div class="delivery-item">
                                                <i class="fad fa-fw fa-shop"></i>
                                                {#if selectedVariant.supplier_id === 4}
                                                    <b>Vyzdvihnutie na predajni - ihneď k odberu</b>
                                                {:else}
                                                    <b>Vyzdvihnutie na predajni do 2-3 prac. dni</b>
                                                {/if}
                                                <p>Košice-okolie, Valaliky, Kostolná 117/18<br/>Po-Pi: 8:00 - 16:00</p>
                                            </div>
                                        {:else}
                                            <div class="deliver-item-non">
                                                Zvolená pneumatika je momentálne nedostupná.
                                            </div>
                                        {/if}
                                    {/if}
                                </div>
                            {/if}
                        </div>
                        <div class="col-lg-6">
                            {#if variantIds.length === 1}
                                <div class="product-delivery mb-4">
                                    {#if selectedVariant}
                                        {#if selectedVariant.stock > 0}
                                            <div class="delivery-item status">
                                                <i class="fad fa-fw fa-truck-fast"></i>
                                                <b>Doručenie</b>
                                                <p>Skladom ({selectedVariant.stock}ks)<br/>Predpokladané doručenie {selectedVariant.delivery}</p>
                                            </div>
                                            <div class="delivery-item">
                                                <i class="fad fa-fw fa-shop"></i>
                                                {#if selectedVariant.supplier_id === 4}
                                                    <b>Vyzdvihnutie na predajni - ihneď k odberu</b>
                                                {:else}
                                                    <b>Vyzdvihnutie na predajni do 2-3 prac. dni</b>
                                                {/if}
                                                <p>Košice-okolie, Valaliky, Kostolná 117/18<br/>Po-Pi: 8:00 - 16:00</p>
                                            </div>
                                        {:else}
                                            <div class="deliver-item-non">
                                                Zvolená pneumatika je momentálne nedostupná.
                                            </div>
                                        {/if}
                                    {/if}
                                </div>
                            {/if}
                            {#if variantIds.length > 1}
                                <div class="product-warehouse mb-4">
                                    <h3>Dostupné sklady:
                                        <Tooltip maxWidth={400} content="Niektoré produkty vieme zabezpečiť z viacerých skladov. Zvoľte si, ktorá cena verzus doba dodania prípadne dátum výroby je pre Vás najvýhodnejší.">
                                            <i class="fas fa-fw fa-info-circle"></i>
                                        </Tooltip>
                                    </h3>
                                    <WarehouseSelect items={data.variants} on:itemSelected={handleSelectVariant} />
                                </div>
                            {/if}
                            {#if variantIds.length < 1}
                                <div class="product-delivery mb-4" class:unavailable={variantIds.length < 1}>
                                    <div class="delivery-item status">
                                        <i class="fad fa-fw fa-truck-fast"></i>
                                        <b>Doručenie</b>
                                        <p>Momentálne nedostupná</p>
                                    </div>
                                    <div class="delivery-item">
                                        <i class="fad fa-fw fa-shop"></i>
                                        <b>Vyzdvihnutie na predajni do 2-3 prac. dni</b>
                                        <p>Košice-okolie, Valaliky, Kostolná 117/18<br/>Po-Pi: 8:00 - 16:00</p>
                                    </div>
                                </div>
                            {/if}
                            <div class="product-buttons" class:unavailable={variantIds.length < 1}>
                                <div class="product-count">
                                    {#if selectedVariant}
                                        <button type="button" on:click={() => {if (amount > 1) amount--}}><i class="far fa-fw fa-minus"></i></button>
                                        <label><input type="number" on:change={handleAmountChanged} bind:value={amount} min="0" max="{selectedVariant.stock || 99}">ks</label>
                                        <button type="button" on:click={() => {if (amount < selectedVariant?.stock) amount++}}><i class="far fa-fw fa-plus"></i></button>
                                    {:else}
                                        <button type="button"><i class="far fa-fw fa-minus"></i></button>
                                        <label><input type="number" value="1">ks</label>
                                        <button><i class="far fa-fw fa-plus"></i></button>
                                    {/if}
                                </div>
                                <button type="button" class="btn btn-slate-50" on:click={fastBuy}><i class="fad fa-fw fa-forward"></i><span>Zrýchlený nákup</span></button>
                                <button type="button" class="btn btn-primary" on:click={addToShoppingCart}><i class="fad fa-fw fa-cart-flatbed-boxes mr-2"></i>Pridať do košíka</button>
                            </div>
                        </div>
                    </div>
                </div>
            {:catch error}
                <div class="col-12">
                    <Error/>
                </div>
            {/await}
        </div>
    </div>
</section>

<style>
    .product {
        padding: 3rem 0;
    }
    .product h3 {
        font-size: 1.15rem;
        margin-bottom: 1rem;
    }
    .product .product-image {
        width: 100%;
        height: 100%;
        padding: 2rem;
        border: 1px solid var(--color-slate-200);
        border-radius: .75rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .product .product-image img {
        width: 100%;
        object-fit: contain;
        -webkit-user-drag: none;
    }
    .product .product-image.single img {
        height: 28rem;
    }
    .product .product-image.multiple img {
        height: 30rem;
    }
    .product .product-image.unavailable img {
        height: 23rem;
    }
    .product .product-header {
        border: 1px solid var(--color-slate-200);
        padding: 1.25rem;
        border-radius: .75rem;
    }
    .product .product-brand .product-logo {
        display: flex;
        justify-content: start;
        align-items: start;
        width: 8rem;
        height: 2rem;
    }
    .product .product-brand .product-logo img {
        max-width: 8rem;
        max-height: 2rem;
    }
    .product .product-brand h2 {
        font-family: Rubik, sans-serif;
        font-weight: 500;
        color: var(--color-slate-900);
        font-size: 1.25rem;
        margin-bottom: -.5rem;
    }
    .product .product-specs {
        display: flex;
        justify-content: end;
        gap: 1rem;
        width: 18rem;
        min-width: 18rem;
    }
    .product .product-specs .spec-item {
        display: flex;
        flex-direction: column;
        color: var(--color-slate-500);
        font-family: Rubik, sans-serif;
        font-weight: 400;
        text-transform: uppercase;
        font-size: .8rem;
        background-color: var(--color-slate-50);
        border-radius: .75rem;
        padding: .75rem 1rem;
    }
    .product .product-specs .spec-item span {
        font-family: Rubik, sans-serif;
        font-weight: 500;
        font-size: 1rem;
    }
    .product .product-desc {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border: 1px solid var(--color-slate-200);
        border-radius: .75rem;
        overflow: hidden;
    }
    .product .product-desc h3 {
        padding: 1.25rem 0 0 1.25rem;
    }
    .product .product-desc .desc-stats {
        display: flex;
        gap: 1.5rem;
        margin-top: 1rem;
        margin-bottom: 1.75rem;
        padding-left: 1.25rem;
    }
    .product .product-desc .desc-stats .stats-item {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }
    .product .product-desc .desc-stats .stats-item i {
        font-size: 1.5rem;
        color: var(--color-slate-500);
    }
    .product .product-desc .desc-stats .stats-item span {
        position: absolute;
        top: -1rem;
        left: 1.25rem;
        padding: .25rem .45rem;
        font-size: .9rem;
        font-weight: 600;
        border-radius: .25rem;
        user-select: none;
        backdrop-filter: brightness(100);
        -webkit-backdrop-filter: brightness(100);
    }
    .product .product-desc ul {
        list-style-type: none;
        height: 100%;
        padding: 0 0 1.25rem 1.25rem;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        color: var(--color-slate-500);
    }
    .product .product-desc ul li {
        font-family: Rubik, sans-serif;
        font-weight: 500;
    }
    .product .product-desc ul li u {
        cursor: help;
        text-decoration: none;
        border-bottom: 1px dashed var(--color-slate-500);
    }
    .product .product-desc ul li span {
        font-family: Rubik, sans-serif;
        font-weight: 400;
    }
    :global(.product .product-desc ul li span img) {
        margin-bottom: -.45rem;
        margin-left: .25rem;
    }
    .product .product-desc .product-price {
        background-color: #E650251A;
        color: #E65025;
        padding: 1rem;
        text-align: center;
        font-family: Rubik, sans-serif;
        font-weight: 600;
        font-size: 1.4rem;
    }
    .product .product-delivery {
        display: flex;
        flex-direction: column;
        padding: 0 1.25rem 0 1.25rem;
        border: 1px solid var(--color-slate-200);
        border-radius: .75rem;
    }
    .product .product-delivery .delivery-item {
        display: flex;
        flex-direction: column;
        padding: 1.25rem .5rem 1.25rem 2rem;
        position: relative;
    }
    .product .product-delivery .delivery-item:first-child {
        border-bottom: 1px solid var(--color-slate-200);
    }
    .product .product-delivery .delivery-item.status:before {
        content: '';
        position: absolute;
        height: .75rem;
        width: .75rem;
        background-color: #47D630;
        border-radius: 50%;
        left: .5rem;
        top: 3.75rem;
    }
    .product .product-delivery.unavailable .delivery-item.status:before {
        background-color: #FF9500;
        top: 3.2rem;
    }
    .product .product-delivery .delivery-item i {
        position: absolute;
        left: 0;
        top: 1.25rem;
        font-size: 1.15rem;
    }
    .product .product-delivery .delivery-item b {
        font-family: Rubik, sans-serif;
        font-weight: 500;
        margin-bottom: .5rem;
    }
    .product .product-delivery .delivery-item p {
        font-family: Rubik, sans-serif;
        font-weight: 400;
        display: flex;
        align-items: center;
        color: var(--color-slate-500);
    }
    .product .product-buttons {
        display: flex;
        gap: 1.5rem;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
    }
		.product .product-buttons .btn {
        flex: 1;
    }
    .product .product-buttons .btn-slate-50 i {
        margin-right: .5rem;
    }
    .product .product-count {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        height: 3.65rem;
        width: 8rem;
        min-width: 8rem;
        border-radius: 2rem;
        background-color: var(--color-slate-50);
        border: 1px solid var(--color-slate-200);
    }
    .product .product-count button {
        background-color: var(--color-slate-200);
        color: var(--color-slate-900);
        border-radius: 50%;
        width: 1.5rem;
        height: 1.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: 0.1s linear;
    }
    .product .product-count button:hover {
        background-color: var(--color-slate-300);
    }
    .product .product-count input {
        width: 1.4rem;
        background-color: transparent;
        border: none;
        text-align: end;
    }
    .product .product-buttons.unavailable .product-count,
    .product .product-buttons.unavailable > button {
        pointer-events: none;
        background-color: var(--color-slate-400);
        border-color: transparent;
        color: rgba(255, 255, 255, .5);
    }
    .product .product-buttons.unavailable .product-count button {
        background-color: var(--color-slate-500);
        color: rgba(255, 255, 255, .5);
    }
    .product .product-buttons.unavailable .product-count input {
        color: rgba(255, 255, 255, .5);
        width: .75rem;
    }
    @media (max-width: 1799.98px) {
        .product .product-buttons .btn-slate-50 i {
            margin-right: 0;
        }
        .product .product-buttons .btn-slate-50 span {
            display: none;
        }
    }
    @media (max-width: 1399.98px) {
        .product .col-xxl-3:has(.product-image) {
            margin-bottom: 1.5rem;
        }
    }
    @media (max-width: 991.98px) {
        .product {
            padding: 3rem 0 0 0;
        }
        .product .product-brand h2 {
            text-align: center;
        }
        .product .product-header .product-logo {
            width: 100%;
            margin-bottom: .5rem;
            justify-content: center;
        }
        .product .product-header .product-specs {
            justify-content: center;
        }
        .product .product-header .product-specs .spec-item {
            text-align: center;
        }
        .product .product-image img {
            height: 35rem;
        }
        .product .product-buttons .btn-slate-50 i {
            margin-right: .5rem;
        }
        .product .product-buttons .btn-slate-50 span {
            display: block;
        }
    }
</style>